import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/helpers/storage.service';

@Injectable({
  providedIn: 'root'
})
export class OtpGuard  {

  constructor(
    private router: Router,
    private storageService: StorageService
  ) { }

  canActivate() {
    try {
      const otpData = this.storageService.getLocalStorage('otpValidation')
      if (!otpData?.transactionId || !otpData.securityCode) {
        return this.router.createUrlTree(['/auth']);
      }
      return true
    } catch (e) {
      return this.router.createUrlTree(['/auth'])
    }
  }
}
